import { useMemo } from 'react';
import { useIntl } from 'react-intl';
import { useLocation, useNavigate, useOutletContext } from 'react-router-dom';
import { match } from 'path-to-regexp';
import queryString from 'query-string';

import { useContentWithSSRProtection } from '@/hooks/useContentWithSSRProtection';
// import { useGetContentQuery } from '@/queries';

const paths = [
  `${process.env.APP_ROUTER_BASENAME}/:productId-:currency-:skuSlug-in-:companySlug/`,
  `${process.env.APP_ROUTER_BASENAME}/:companySlug-b/`,
  `${process.env.APP_ROUTER_BASENAME}/:landing/`,
];

export const getMatchParams = ({ pathname }) =>
  paths.map((item) => match(item)(pathname)).find((item) => item)?.params || {};

export const getPageParams = (location) => {
  const params = getMatchParams({
    pathname: location.pathname,
  });

  return {
    ...params,
    ...queryString.parse(location.search || ''),
  };
};

export const usePageProps = () => {
  const location = useLocation();
  const intl = useIntl();
  const routerContext = useOutletContext();
  const navigate = useNavigate();

  const {
    data: contentData,
    status: contentStatus,
    error,
  } = useContentWithSSRProtection({
    locale: intl.locale,
    pathname: location.pathname,
  });

  const isErrorContent = error?.isError || false;

  const contentParams = contentData?.filters || {};
  const currentParams = getPageParams(location);

  const selectorProps = useMemo(
    () => ({
      location,
      params: {
        ...currentParams,
        ...(contentParams || {}),
      },
      intl,
      navigate,
      pageName: location?.pathname,
      routerContext: routerContext || {},
    }),
    [
      currentParams,
      contentParams,
      intl,
      navigate,
      location,
      isErrorContent,
      contentStatus,
    ]
  );

  return selectorProps;
};

export default usePageProps;
